module.exports = __webpack_public_path__ + "static/media/2 Minutes-18 Nove. 2021 DCP IEG.5a571a14.docx";